<div class="card">

  <div class="data-header">

    <button mat-raised-button color="primary" (click)="openDialog()">
      <mat-icon>add</mat-icon>
      Nouveau collaborateur
    </button>

    <mat-form-field class="filter-field">
      <mat-label>Filtre</mat-label>
      <input matInput [ngModel]="searchTerm" (ngModelChange)="onSearchChange($event)"
             placeholder="Nom ou prénom...">
    </mat-form-field>

    <mat-button-toggle-group [value]="statutFiltre" (change)="onStatutChange($event.value)" class="statut-toggle">
      <mat-button-toggle value="ACTIFS">Actifs</mat-button-toggle>
      <mat-button-toggle value="INACTIFS">Inactifs</mat-button-toggle>
      <mat-button-toggle value="TOUS">Tous</mat-button-toggle>
    </mat-button-toggle-group>

  </div>

  <div class="table-scroll-wrapper">

    <mat-table
      class="mat-elevation-z8 table-container"
      [dataSource]="collaborateurs"
      matSort
      matSortDisableClear
      [matSortActive]="sortField"
      [matSortDirection]="sortDirection"
      (matSortChange)="onSortChange($event)">

      <!-- Nom -->
      <ng-container matColumnDef="nom">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Nom</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.nom }}</mat-cell>
      </ng-container>

      <!-- Prénom -->
      <ng-container matColumnDef="prenom">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Prénom</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.prenom }}</mat-cell>
      </ng-container>

      <!-- Postes -->
      <ng-container matColumnDef="postes">
        <mat-header-cell *matHeaderCellDef>Poste(s)</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span *ngIf="row.postes?.length; else noPoste">
            {{ postesLabel(row) }}
          </span>
          <ng-template #noPoste>—</ng-template>
        </mat-cell>
      </ng-container>

      <!-- Statut -->
      <ng-container matColumnDef="statut">
        <mat-header-cell *matHeaderCellDef mat-sort-header="active">Statut</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="status-badge" [ngClass]="row.active ? 'status-active' : 'status-inactive'">
            {{ row.active ? 'Actif' : 'Inactif' }}
          </span>
        </mat-cell>
      </ng-container>

      <!-- Date de création -->
      <ng-container matColumnDef="dateCreation">
        <mat-header-cell *matHeaderCellDef mat-sort-header="createdAt">Date création</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.createdAt | date:'dd/MM/yyyy HH:mm' }}</mat-cell>
      </ng-container>

      <!-- CV -->
      <ng-container matColumnDef="cv">
        <mat-header-cell *matHeaderCellDef>CV</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <ng-container *ngIf="row.hasCv">
            <button mat-icon-button
                    (click)="openCv(row)"
                    [disabled]="openingCvId === row.collabId"
                    matTooltip="Ouvrir le CV dans un nouvel onglet">
              <mat-icon *ngIf="openingCvId !== row.collabId">open_in_new</mat-icon>
              <mat-spinner *ngIf="openingCvId === row.collabId" diameter="18"></mat-spinner>
            </button>
            <button mat-icon-button (click)="downloadCv(row)" matTooltip="Télécharger le CV">
              <mat-icon>file_download</mat-icon>
            </button>
          </ng-container>
          <span *ngIf="!row.hasCv">—</span>
        </mat-cell>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="actions-td">Actions</mat-header-cell>
        <mat-cell *matCellDef="let row" class="actions-td">

          <button mat-icon-button
                  (click)="openDialog(row)"
                  matTooltip="Modifier"
                  color="primary">
            <mat-icon>mode_edit</mat-icon>
          </button>

          <button mat-icon-button
                  *ngIf="row.active"
                  (click)="toggleActivation(row)"
                  matTooltip="Désactiver"
                  color="warn">
            <mat-icon>block</mat-icon>
          </button>

          <button mat-icon-button
                  *ngIf="!row.active"
                  (click)="toggleActivation(row)"
                  matTooltip="Réactiver"
                  color="accent">
            <mat-icon>check_circle</mat-icon>
          </button>

        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

    <div class="no-data-cell" *ngIf="!loading && collaborateurs.length === 0">
      <mat-icon>search_off</mat-icon>
      Aucun collaborateur trouvé
    </div>

  </div>

  <mat-paginator
    [length]="totalElements"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 20, 50, 100]"
    (page)="onPageChange($event)"
    showFirstLastButtons>
  </mat-paginator>

</div>